import { render, staticRenderFns } from "./DateColumnTable.vue?vue&type=template&id=2b0bae0c&scoped=true&"
import script from "./DateColumnTable.vue?vue&type=script&lang=js&"
export * from "./DateColumnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bae0c",
  null
  
)

export default component.exports